var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.777,
    height: 6.919,
    viewBox: "0,0,256,150.39063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#262626",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.17682,-52.81556) rotate(90) scale(21.73728,21.73728)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.777,-101.478) rotate(90)",
    id: "right-arrow_1_"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.478,0)",
    id: "Group_2650"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-101.478,0)",
    d: "M108.209,5.429l-5.241,-5.241c-0.25198,-0.25056 -0.65902,-0.25056 -0.911,0l-0.386,0.386c-0.25111,0.25175 -0.25111,0.65925 0,0.911l4.4,4.4l-4.406,4.406c-0.25056,0.25198 -0.25056,0.65902 0,0.911l0.386,0.386c0.25198,0.25056 0.65902,0.25056 0.911,0l5.246,-5.245c0.25037,-0.25323 0.25037,-0.66077 0,-0.914z",
    id: "Path_6875"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.dd1b90b00f75d5d78aeac9d18610b9c4.svg";
export { ForwardRef as ReactComponent };